import React from 'react';
import { useNavigate } from 'react-router-dom';

import Logo from '../Components/Logo';
import Profile from '../Components/Profile';

import styles from '../Styles/Account.module.css';

const Account = () => {
  const navigate = useNavigate();

  return (
    <div className='main'>
      <div className='headerWithBack'>
          <a className='button' href='/'>На главную</a>
          <Logo to='/' position='relative' />
      </div>
      <div className={styles.horizontalData}>
        <div className={styles.boxPanel}>
          <Profile />
        </div>
        <div className={styles.boxPanel}>
          <div className={styles.verticalData}>
            <h1>Разделы</h1>
            <a className='textButton' onClick={() => {navigate('/users');}}>Пользователи</a>
            <a className='textButton' onClick={() => {navigate('/site-main-images');}}>Редактирование изображений главной страницы</a>
            <a className='textButton' onClick={() => {navigate('/fields');}}>Редактирование текстовых полей главной страницы</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Account;